export const arrToConvert = (input_obj) => {
  const input_arr = Object.values(input_obj);
  
  let new_arr = [];
  for (var i = 0; i < input_arr.length; i++) {
    new_arr = new_arr.concat(input_arr[i]);
  }
  return new_arr
}